import React, { CSSProperties, useMemo } from 'react';
import Skeleton, { SkeletonProps } from 'react-loading-skeleton';
import styled from 'styled-components';

export interface IfSkeletonPropsType extends SkeletonProps {
  /** 스켈레톤 보여줘야 하는지 여부 false 인경우 children 을 노출 */
  isSkeleton?: boolean;
  children?: React.ReactNode | React.ReactNode[];
  containerStyle?: CSSProperties;
  /**
   * 컨테이너 width 100%;
   */
  containerW100P?: boolean;
  /**
   * 컨테이너 height 100%
   */
  containerH100P?: boolean;
  /**
   * 컨테니언 width, height 100%;
   */
  containerWH100P?: boolean;
  className?: string;
  borderRadius?: React.CSSProperties['borderRadius'];
}

/**
 * isSkeleton 값에 따라 스켈레톤 UI를 보여준다.
 * @author 이현우
 * @param param0
 * @returns
 */
function IfSkeleton({
  isSkeleton,
  children,
  containerStyle,
  containerW100P,
  containerH100P,
  containerWH100P,
  className,
  style,
  borderRadius = 0,
  ...props
}: IfSkeletonPropsType) {
  const defaultContainerStyles = useMemo(() => {
    if (containerWH100P) {
      return {
        width: '100%',
        height: '100%',
      };
    } else if (containerW100P) {
      return {
        width: '100%',
      };
    } else if (containerH100P) {
      return {
        height: '100%',
      };
    }
    return {};
  }, [containerH100P, containerW100P, containerWH100P]);

  if (!isSkeleton) return <>{children}</>;

  return (
    <SkeletonBox
      style={{
        ...defaultContainerStyles,
        ...containerStyle,
        borderRadius,
      }}
      className={className}
    >
      <Skeleton
        style={{
          display: 'flex',
          alignItems: 'center',
          ...style,
          borderRadius,
        }}
        {...props}
      />
    </SkeletonBox>
  );
}

export default IfSkeleton;

const SkeletonBox = styled.div`
  display: inline-block;
`;
